<template>

    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box" :class="'activeTab_'+activeTab">
          <tabs type="boxed" @tab-selected="tabSelected">
            <tab-pane :label="$t('campaigns.campaignParams.campaignsParameters')">
              <label class="label">{{$t('common.title')}}</label>
              <p class="control">
                <input v-model="campaign.namePostfix" class="input" type="text" :placeholder="$t('campaigns.putCampaignsName')" :readonly="!canEdit()">
              </p>
              <label class="label">{{$t('campaigns.campaignParams.callDate')}}</label>
              <datepicker :disabled="!canEdit()&&!canContinue()" v-model="campaign.date"  class="date" :placeholder="$t('campaigns.campaignParams.putCallDate')" :config="{ wrap: true, dateFormat: 'd.m.Y', locale: l10n }">
                <a class="button" data-toggle  :disabled="!canEdit()&&!canContinue()"><i class="fa fa-calendar"></i></a>
                <a class="button" data-clear  :disabled="!canEdit()&&!canContinue()"><i class="fa fa-close"></i></a>
              </datepicker>
              <label class="label">{{$t('campaigns.campaignParams.timezone')}} (UTC)</label>
              <p class="control">
              <span class="select">
                <select v-model="campaign.zoneOffset" :disabled="!canEdit()">
                  <option>0</option>
                  <option>+1</option>
                  <option>+2</option>
                  <option>+3</option>
                  <option>+4</option>
                  <option>+5</option>
                  <option>+6</option>
                  <option>+7</option>
                  <option>+8</option>
                  <option>+9</option>
                  <option>+10</option>
                  <option>+11</option>
                  <option>+12</option>
                </select>
              </span>
              </p>
              <label class="label">{{$t('campaigns.campaignParams.callTime')}}</label>
              <p class="control has-addons">
                <!--С<datepicker  :disabled="!canEdit()&&!canContinue()" v-model="campaign.timeStart" class="time" placeholder="Начало прозвона" :config="{ time_24hr: true, enableTime: true, enableSeconds: false, noCalendar: true }" value="10:00"></datepicker>
                &nbsp;&nbsp;До<datepicker :disabled="!canEdit()&&!canContinue()"  v-model="campaign.timeEnd" class="time" placeholder="Завершение прозвона" :config="{ time_24hr: true, enableTime: true, enableSeconds: false, noCalendar: true }" value="18:00"></datepicker>-->
                {{$t('common.timeInterval.from')}}<input v-model="campaign.timeStart" class="time" type="text" pattern="(([0,1][0-9])|(2[0-3])):[0-5][0-9]" placeholder="XX:XX" value="10:00" :readonly="!canEdit()&&!canContinue()" :onblur="transformTimeStart()">
                &nbsp;&nbsp;{{$t('common.timeInterval.to')}}<input v-model="campaign.timeEnd" class="time" type="text" pattern="(([0,1][0-9])|(2[0-3])):[0-5][0-9]" placeholder="XX:XX" value="18:00" :readonly="!canEdit()&&!canContinue()" :onblur="transformTimeEnd()">
              </p>
              <label class="label">{{$t('campaigns.campaignParams.numberOfAttemptsToGetThrough')}}</label>
              <span class="select">
                <select v-model="campaign.postponingAttempts" :disabled="!canEdit()">
                  <option>0</option>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                </select>
              </span>
              <label class="label">{{$t('campaigns.campaignParams.intervalBetweenRepeatedCalls')}} ({{$t('common.time.minutes')}})</label>
              <span class="select">
                <select v-model="campaign.postponingIntervalMin" :disabled="!canEdit()">
                  <option>30</option>
                  <option>60</option>
                  <option>120</option>
                  <option>240</option>
                </select>
              </span>
              <label class="label">{{$t('scenarios.scenario')}}</label>
              <p class="control">
              <span class="select">
                <select v-model="campaign.scenario" :disabled="!canEdit()" v-on:click="getScenarioReadyState">
                  <option v-for="scenario in scenarios" v-bind:value="scenario.id">
                    {{scenario.name}}
                  </option>
                </select>
              </span>
                <button v-if="campaign.scenario" class="button is-info" v-on:click="gotoScenario">
                <span class="icon">
                  <i class="fa fa-edit"></i>
                </span>
                  <span>{{$t('campaigns.campaignParams.openScenario')}}</span>
                </button>
                <button v-if="isReadyScenario" class="button is-success is-outlined" :disabled="true">
                  <span class="icon">
                    <i class="fa fa-info"></i>
                  </span>
                  <span>{{$t('campaigns.campaignParams.scenarioIsReady')}}</span>
                </button>
                <button v-else class="button is-danger is-outlined" :disabled="true">
                  <span class="icon">
                    <i class="fa fa-info"></i>
                  </span>
                  <span>{{$t('campaigns.campaignParams.scenarioIsNotReady')}}</span>
                </button>
              </p>
              <label class="label">{{$t('campaigns.campaignParams.base')}}</label>
              <div class="control">
                <input class="button is-info" :disabled="!canEdit()" type="button" id="uploadFile" :value="$t('common.actions.loadFromFile')" @click="uploadFile('uploadPhones')">
                <input style="display:none;" @input="uploadPhones('uploadPhones')" :id="`uploadPhones`" name="load-phones" type="file" accept=".txt,.csv,.xls,.xlsx">
                <button  :disabled="!canEdit()" class="button is-info" v-on:click="openModalClipboard">
                  <span class="icon">
                    <i class="fa fa-clipboard"></i>
                  </span>
                  <span>{{$t('campaigns.putBaseFromClipboard')}}</span>
                </button>
                <button v-if="tasksCount>0" class="button is-info" v-on:click="viewCallTasks">
                <span class="icon">
                  <i class="fa fa-list-alt"></i>
                </span>
                  <span>{{$t('campaigns.campaignParams.viewBase')}}</span>
                </button>
                <button v-if="tasksCountPerformed==0 && tasksCount>0 && !campaign.archiveStatus" :disabled="!canEdit()" class="button is-light delete-button" v-on:click="openModalDelete">
                <span class="icon">
                  <i class="fa fa-minus-circle"></i>
                </span>
                  <span>{{$t('campaigns.campaignParams.removeBase')}}</span>
                </button>
                <button v-if="canContinue()" class="button is-warning" v-on:click="getReadyCallTasksCSV">
                  <span class="icon">
                    <i class="fa fa-info"></i>
                  </span>
                  <span>{{$t('campaigns.unprocessed')}} {{$t('campaigns.campaignParams.numbers')}}</span>
                </button>
              </div>
              <p>{{$t('campaigns.campaignParams.uploadedNumbers')}}: {{tasksCount}}</p>
              <label class="label">{{$t('testCall.testCall')}}</label>
              <div class="control is-grouped">
              <p class="control">
                <button :disabled="campaign.archiveStatus" class="button is-primary" v-on:click="callTest(true)">
                  <span class="icon">
                    <i class="fa fa-volume-control-phone"></i>
                  </span>
                  <span>{{$t('testCall.callToNumber')}}</span>
                </button>
              </p>
              <p class="control is-expanded">
                <input :disabled="campaign.archiveStatus" v-model="testPhone" class="input" type="text" :placeholder="$t('testCall.putNumber')">
              </p>
              <p class="control is-expanded">
                <button class="button is-info" v-on:click="viewTestCallTasks">
                  <span class="icon">
                    <i class="fa fa-list-alt"></i>
                  </span>
                  <span>{{$t('testCall.viewTestResults')}}</span>
                </button>
              </p>
              </div>
              <div v-if="!campaign.archiveStatus" class="control">
                <collapse accordion>
                  <collapse-item :title="$t('testCall.testCallParameters')">
                    <div class="table-responsive">
                      <table class="table is-bordered is-striped is-narrow">
                        <thead>
                        <tr>
                          <th>{{$t('common.key')}}</th>
                          <th>{{$t('common.value')}}</th>
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(param, index) in testPhoneParametersArray">
                          <td>
                            <input v-model="param[0]" class="input" type="text">
                          </td>
                          <td>
                            <input v-model="param[1]" class="input" type="text">
                          </td>
                          <td>
                            <button class="button is-light" v-on:click="deleteTestPhoneParameter(index)" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-minus-circle"></i>
                      </span>
                              <span>{{$t('common.actions.delete')}}</span>
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td><button class="button is-light" v-on:click="addTestPhoneParameter" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-plus-circle"></i>
                      </span>
                            <span>{{$t('common.actions.add')}}</span>
                          </button></td>
                          <td></td>
                          <td></td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </collapse-item>
                </collapse>
              </div>
              <br>

            </tab-pane>

            <tab-pane v-if="canAccessAdditionalParameters(permissionKey)" :label="$t('campaigns.additionalParameters.additionalParameters')">
              <label  class="label">FS Gateway</label>
              <p  class="control">
              <span class="select">
                <select v-model="campaign.gateway" :disabled="!canEdit()">
                  <option v-for="fsGateway in fsGateways" v-bind:value="fsGateway.name">
                    {{fsGateway.name}}
                  </option>
                </select>
              </span>
              </p>
              <label class="label">Приоритет</label>
              <p class="control">
                <input v-model="campaign.priority" class="input" type="text" placeholder="Приоритет рассылки" :readonly="!canEdit()">
              </p>
              <label class="label">Record Host</label>
              <p class="control">
                <input v-model="campaign.recordHost" class="input" type="text" :readonly="!canEdit()">
              </p>
              <label class="label">Postponing Strategy</label>
              <p class="control">
                <input v-model="campaign.postponingStrategy" class="input" type="text" :readonly="!canEdit()">
              </p>
              <label class="label">Schedule Strategy</label>
              <p class="control">
                <input v-model="campaign.scheduleStrategy" class="input" type="text" :readonly="!canEdit()">
              </p>
              <label class="label">Tel Error Strategy</label>
              <p class="control">
                <input v-model="campaign.telErrorStrategy" class="input" type="text" :readonly="!canEdit()">
              </p>
              <label class="label">Dialplan Context</label>
              <p class="control">
                <input v-model="campaign.dialplanContext" class="input" type="text" :readonly="!canEdit()">
              </p>
              <label class="label">Dialplan Extension</label>
              <p class="control">
                <input v-model="campaign.dialplanExtension" class="input" type="text" :readonly="!canEdit()">
              </p>
              <label class="label">Target Strategy</label>
              <p class="control">
                <input v-model="campaign.targetStrategy" class="input" type="text" :readonly="!canEdit()">
              </p>
              <label class="label">Phone Preprocessing Strategy</label>
              <p class="control">
                <input v-model="campaign.phonePreprocessingStrategy" class="input" type="text" :readonly="!canEdit()">
              </p>
              <div class="table-responsive">
                <table class="table is-bordered is-striped is-narrow">
                  <thead>
                  <tr>
                    <th>{{$t('common.key')}}</th>
                    <th>{{$t('common.value')}}</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(param, index) in phonePreprocessingParametersArray">
                    <td>
                      <input v-model="param[0]" class="input" type="text" :readonly="!canEdit()">
                    </td>
                    <td>
                      <input v-model="param[1]" class="input" type="text" :readonly="!canEdit()">
                    </td>
                    <td>
                      <button :disabled="!canEdit()" class="button is-light" v-on:click="deletePhonePreprocessingParameter(index)" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-minus-circle"></i>
                      </span>
                        <span>{{$t('common.actions.delete')}}</span>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td><button :disabled="!canEdit()" class="button is-light" v-on:click="addPhonePreprocessingParameter" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-plus-circle"></i>
                      </span>
                      <span>{{$t('common.actions.add')}}</span>
                    </button></td>
                    <td></td>
                    <td></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </tab-pane>
            <tab-pane :label="$t('campaigns.quotas.quotas')" v-if="quotaServiceAvailable && campaign && campaign.id">
              <div class="quotasShell">
                <CampaignQuota :campaign-id="campaign.id" @serviceNotAvailable="quotaServiceNotAvailable"/>
              </div>
            </tab-pane>
          </tabs>
          <p class="control toolButtons">
            <button  v-if="canEdit()||canContinue()" class="button is-primary" v-on:click="save(true)">
                <span class="icon">
                  <i class="fa fa-floppy-o"></i>
                </span>
              <span>{{$t('common.actions.save')}}</span>
            </button>
            <button v-if="canSetReadyStatus() && !campaign.archiveStatus" :disabled="!canEdit()" class="button is-info" v-on:click="openModalReady" v-bind:disabled="appconfig.disableCampaignSetReadyState">
                <span class="icon">
                  <i class="fa fa-check-circle"></i>
                </span>
              <span>{{$t('common.actions.run')}}</span>
            </button>
            <button v-if="canPauseStatus()" class="button is-info" v-on:click="openModalStop">
                      <span class="icon">
                        <i class="fa fa-stop-circle"></i>
                      </span>
              <span>{{$t('common.actions.stop')}}</span>
            </button>
            <!--<button v-if="campaign.state=='Завершена' && !campaign.reportCreated" class="button is-info" v-on:click="prepareReport">
                    <span class="icon">
                      <i class="fa fa-calculator"></i>
                    </span>
              <span>Подготовить отчет</span>
            </button>-->
            <div class="report">
                <ReportGenerator :campaign-id="id" :check-status-when-created="true"/>
                <div>
                  <button class="button is-info" v-on:click="downloadTestReport"><span>{{$t('campaigns.campaignParams.reportByTestCalls')}}</span></button>
                </div>
            </div>
            <button v-if="canLoadReport(campaign)" class="button is-info" v-on:click="viewCallsResult">
              <span>{{$t('campaigns.campaignParams.callResult')}}</span>
            </button>
            <button class="button is-light" v-on:click="cancel">
                <span class="icon">
                  <i class="fa fa-times-circle"></i>
                </span>
              <span>{{$t('common.actions.close')}}</span>
            </button>
            <button v-if="!campaign.archiveStatus && canAccessAdditionalParameters(permissionKey)" class="button is-info" v-on:click="viewMonitor">
                <span class="icon">
                  <i class="fa fa-tv"></i>
                </span>
              <span>{{$t('campaigns.campaignParams.callsMonitoring')}}</span>
            </button>
          </p>
          </article>
        <modal :visible="showModal" :title=title :confirmation=confirmation :clipboard=!confirmation @confirm="confirmAction" @close="closeModal"></modal>
      </div>
    </div>

</template>

<script>
  import Datepicker from 'vue-bulma-datepicker'
  import Cleave from 'vue-cleave'
  import Modal from './Modal'
  import {mapGetters} from 'vuex'
  import Vue from 'vue'
  import Notification from 'vue-bulma-notification'
  import {TabPane, Tabs} from 'vue-bulma-tabs'
  import {Collapse, Item as CollapseItem} from 'vue-bulma-collapse'
  import Message from 'vue-bulma-message'
  import CheckToken from '../authentication/CheckToken'
  import CheckPermission from '../authentication/CheckPermission'
  import CampaignQuota from './quota/CampaignQuota'
  import ReportGenerator from './ReportGenerator'

  Vue.mixin(CheckToken)
  Vue.mixin(CheckPermission)

  const NotificationComponent = Vue.extend(Notification)
  const openNotification = (propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
  duration: 4500,
  container: '.notifications'
}) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  })
}

const MessageComponent = Vue.extend(Message)
const openMessage = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 10000,
  container: '.messages'
}) => {
  return new MessageComponent({
    el: document.createElement('div'),
    propsData
  })
}

const CAMPAIGNS_API = '/api/campaigns'
const CAMPAIGNS_CTS_API = '/outgoing-cpg-sec'
const SCENARIOS_API = '/api/scenarios'
const PHONEBASEUPLOADING_API = '/outgoing-cpg-sec'
const CALLTASKS_API = '/outgoing-cpg-sec'
const APPCONFIG_API = '/api/appConfig'
const FSGATEWAY_API = 'api/fsgateways'
const PROFILES_API = '/api/profiles'
const CALLTASKTESTING_API = '/outgoing-cpg-sec/callTasksTesting'
// const REPORTS_API = '/calls'
const TEST_REPORTS_GENERATE_API = '/report/testReport'

export default {
  props: ['id', 'idcopy'],
  components: {
    ReportGenerator,
    CampaignQuota,
    Datepicker,
    Cleave,
    Modal,
    Notification,
    Message,
    Tabs,
    TabPane,
    Collapse,
    CollapseItem
  },
  computed: {
    ...mapGetters([
      'loggedUser',
      'loggedId',
      'loggedRole',
      'clientId',
      'authenticationToken'
    ]),
    l10n () {
      return {
        firstDayOfWeek: 1,
        weekdays: {
          shorthand: Object.values(this.$i18n.messages[this.$i18n.locale].common.date.days.shorthand),
          longhand: Object.values(this.$i18n.messages[this.$i18n.locale].common.date.days.longhand)
        },
        months: {
          shorthand: Object.values(this.$i18n.messages[this.$i18n.locale].common.date.months),
          longhand: Object.values(this.$i18n.messages[this.$i18n.locale].common.date.months)
        }
      }
    }
  },
  methods: {
    prepareSecurityHeader() {
      console.log(this.authenticationToken)
      return {
        Authorization: `Bearer ${this.authenticationToken}`,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      }
    },
    prepareSecurityHeaderYandex(uuid) {
      return {
        'Content-Type': 'application/json',
        'Idempotence-Key': uuid
      }
    },
    tabSelected(index) {
      this.activeTab = index
    },
    transformTimeStart () {
      this.campaign.timeStart = this.transform(this.campaign.timeStart)
    },
    transformTimeEnd () {
      this.campaign.timeEnd = this.transform(this.campaign.timeEnd)
    },
    transform (tt) {
      let t = tt
      if (t != null) {
        if (t.length === 3) {
          let part1 = t.substr(0, 2)
          let part2 = t.substr(2)
          if (part2 !== ':') {
            t = part1 + ':' + part2
          }
        }
        if (t.length > 5) {
          t = t.substr(0, 5)
        }
      } else {
        t = '12:00'
      }
      return t
    },
    save (showMessage) {
      if (this.checkTime()) {
        this.campaign.phonePreprocessingParameters = {}
        for (let i = 0; i < this.phonePreprocessingParametersArray.length; i++) {
          let item = this.phonePreprocessingParametersArray[i]
          this.campaign.phonePreprocessingParameters[item[0]] = item[1]
        }
        if (!this.campaign.id) {
          this.saveNew(showMessage)
        } else {
          this.update(showMessage)
        }
      } else {
        this.openNotificationWithType('warning', 'Неверно указано время рассылки.')
      }
    },
    saveNew (showMessage) {
        let that = this
      console.log('saving new campaign: ' + JSON.stringify(this.campaign))
      this.$http.post(CAMPAIGNS_API, this.campaign, { headers: this.prepareSecurityHeader() })
      .then((response) => {
        console.log(response.data)
          that.isSaved = true
          that.campaign = response.data
        if (showMessage) {
            that.openNotificationWithType('info', 'Рассылка сохранена.')
        }
//        that.$router.push('/campaigns/')
      }).catch((error) => {
        console.log(error)
          that.openNotificationWithType('danger', 'Ошибка сохранения рассылки. ')
      })
    },
    update (showMessage) {
        let that = this
      console.log('updating campaign: ' + JSON.stringify(this.campaign))
      this.$http.put(CAMPAIGNS_API, this.campaign, { headers: this.prepareSecurityHeader() })
      .then((response) => {
        console.log(response.data)
          that.isSaved = true
        if (showMessage) {
            that.openNotificationWithType('info', 'Рассылка сохранена.')
        }
//        this.$router.push('/campaigns/')
      }).catch((error) => {
        console.log(error)
          that.openNotificationWithType('danger', 'Ошибка сохранения рассылки. ')
      })
    },
    uploadFile(buttonId) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить рассылку')
      } else {
        document.getElementById(buttonId).click()
      }
    },
    loadState () {
        let that = this
      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then((response) => {
          that.isActive = response.data
        if (!that.isActive && !that.campaign.archiveStatus) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          })
        }
      }).catch((error) => {
        console.log(error)
          that.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].scenarios.errorToGetUserStatus)
      })
    },
    loadAppConfig () {
        let that = this
      this.$http.get(APPCONFIG_API, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          that.appconfig = response.data
          that.campaign.gateway = that.appconfig.defaultGateway
          that.campaign.scheduleStrategy = that.appconfig.defaultScheduleStrategy
          that.campaign.postponingStrategy = that.appconfig.defaultPostponingConfig.strategy
          that.campaign.telErrorStrategy = that.appconfig.defaultTelErrorStrategy.strategy
          that.campaign.postponingAttempts = that.appconfig.defaultPostponingConfig.parameters.attempts
          that.campaign.postponingIntervalMin = that.appconfig.defaultPostponingConfig.parameters.waitMinutes
          that.campaign.dialplanContext = that.appconfig.defaultDialplanContext
          that.campaign.dialplanExtension = that.appconfig.defaultDialplanExtension
          that.campaign.targetStrategy = that.appconfig.defaultTargetStrategy
          that.campaign.phonePreprocessingStrategy = that.appconfig.defaultPhonePreprocessingStrategy.strategy
          that.campaign.recordHost = that.appconfig.defaultRecordHost
          that.phonePreprocessingParametersArray = Object.entries(that.appconfig.defaultPhonePreprocessingStrategy.parameters)

          that.initStartCampaign()
        })
        .catch((error) => {
          console.log(error)
            that.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ')
        })
    },
    loadCampaign () {
      let that = this
      this.$http({
        url: CAMPAIGNS_API + '/' + this.$props.id,
        headers: this.prepareSecurityHeader()
      }).then((response) => {
        console.log('opening campaign ' + response.data.id)
        that.campaign = response.data
        that.phonePreprocessingParametersArray = that.campaign.phonePreprocessingParameters ? Object.entries(that.campaign.phonePreprocessingParameters) : []
        that.loadTasksCount()
        that.loadTasksCountPerformed()
        that.isSaved = true
        that.getScenarioReadyState()
        that.loadState()
        that.getScenario()
      }).catch((error) => {
        console.log(error)
        that.openNotificationWithType('danger', 'Ошибка загрузки рассылки. ')
      })
    },
    deletePhonePreprocessingParameter(index) {
      this.phonePreprocessingParametersArray.splice(index, 1)
    },
    addPhonePreprocessingParameter() {
      this.phonePreprocessingParametersArray.push({})
    },
    deleteTestPhoneParameter(index) {
      this.testPhoneParametersArray.splice(index, 1)
    },
    addTestPhoneParameter() {
      this.testPhoneParametersArray.push({})
    },
    copyCampaign () {
      let that = this
      this.$http({
        url: CAMPAIGNS_API + '/' + this.$props.idcopy,
        headers: this.prepareSecurityHeader()
      }).then((response) => {
        console.log('copying campaign ' + response.data.id)
        that.campaign = response.data
        that.campaign.id = undefined
        that.notSaved()
        that.loadState()
      }).catch((error) => {
        console.log(error)
        this.openNotificationWithType('danger', 'Ошибка создания копии рассылки. ')
      })
    },
    loadScenarios () {
        let that = this
        this.$http.get(SCENARIOS_API + '/names', {headers: this.prepareSecurityHeader()})
        .then((response) => {
            that.scenarios = response.data
        })
        .catch((error) => {
            console.log(error)
            that.openNotificationWithType('danger', 'Ошибка загрузки сценариев. ')
        })
    },
    loadFsGateways () {
        let that = this
      this.$http.get(FSGATEWAY_API, {headers: this.prepareSecurityHeader()})
        .then((response) => {
            that.fsGateways = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    loadTasksCount () {
        let that = this
      this.$http.get(CALLTASKS_API + '/' + this.campaign.id + '/count', {headers: this.prepareSecurityHeader()})
        .then((response) => {
            that.tasksCount = response.data
        })
        .catch((error) => {
            console.log(error)
        })
    },
    loadTasksCountPerformed () {
        let that = this
      this.$http.get(CALLTASKS_API + '/' + this.campaign.id + '/countPerformed', {headers: this.prepareSecurityHeader()})
        .then((response) => {
            that.tasksCountPerformed = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getScenarioReadyState() {
      this.getScenario()
        let that = this
      this.$http({
        url: SCENARIOS_API + '/isReady/' + this.campaign.scenario,
        headers: this.prepareSecurityHeader()
      }).then((response) => {
          that.isReadyScenario = response.data
      }).catch((error) => {
        console.log(error)
          that.openNotificationWithType('danger', 'Ошибка получения состояния сценария. ')
      })
    },
    getScenario() {
      if (this.campaign.scenario) {
        let that = this
        this.$http.get(SCENARIOS_API + '/' + this.campaign.scenario, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            that.loadedScenario = response.data

            console.log('loadedScenario ' + that.loadedScenario)
          })
          .catch((error) => {
            console.log(error)
            that.openNotificationWithType('danger', that.$i18n.messages[that.$i18n.locale].notifications.scenario.errorLoadScenario)
          })
        return that.loadedScenario
      }
    },
    checkContainsAudio() {
      let states = this.loadedScenario.parameters.states
      for (let i = 0; i < states.length; i++) {
        if (!states[i].data.audio && states[i].type !== 'inOutState') {
          return false
        }
      }
      return true
    },

    openModalDelete () {
      console.log('Нажали удалить базу')
      this.title = 'Удалить базу?'
      this.confirmation = true
      this.openModal()
    },
    openModalReady () {
      if (this.checkContainsAudio()) {
        this.title = 'Запустить рассылку?'
        this.confirmation = true
        this.openModal()
      } else {
        this.openNotificationWithType('danger', 'Нельзя запустить рассылку со сценарием, где нет аудио')
      }
    },
    openModalStop () {
        this.title = 'Остановить рассылку?'
        this.confirmation = true
        this.openModal()
    },
    openModalClipboard () {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой базы необходимо сохранить рассылку')
      } else {
        this.title = 'Загрузка базы'
        this.confirmation = false
        this.openModal()
      }
    },
    closeModal () {
      this.showModal = false
    },
    openModal () {
      this.showModal = true
    },
    confirmAction (value) {
      this.closeModal()
      if (this.title == 'Запустить рассылку?') {
        // this.save(false)
        this.setReadyStatus()
      }
      if (this.title == 'Остановить рассылку?') {
        // this.save(false)
        this.setPauseStatus()
      }
      if (this.title == 'Удалить базу?') {
        this.deletePhones()
      }
      if (this.title == 'Загрузка базы') {
        this.clipboard = value
        this.uploadPhonesFromClipboard()
      }
    },
    uploadPhonesFromClipboard() {
      this.handleUploadPhonesFromClipboardRequest()
    },
    handleUploadPhonesFromClipboardRequest () {
      this.$http.post(PHONEBASEUPLOADING_API + '/' + 'loadForCampaignFromClipboard', this.prepareClipboardMultipartFile(this.clipboard, this.campaign.id),
        {headers: this.prepareSecurityHeader(), timeout: 180000})
        .then(response => {
          if (response.status === 200) {
            if (response.data.message === '' || response.data.message === 'Загрузка прошла успешно') {
              this.openNotificationWithType('info', 'База загружена.')
              this.loadTasksCount()
            } else {
              this.openNotificationWithType('danger', response.data.message, 0)
              this.loadTasksCount()
            }
          } else {
            this.openNotificationWithType('danger', 'Ошибка загрузки файла')
            this.loadTasksCount()
          }
        })
        .catch(error => {
          this.openNotificationWithType('danger', 'Ошибка загрузки файла')
          this.loadTasksCount()
          console.log(error)
        })
      this.loadTasksCountPerformed()
    },
    prepareClipboardMultipartFile (phonesClipboard, phonesCampaign) {
      const phonesFormData = new FormData()
      phonesFormData.append('clipboard', phonesClipboard)
      phonesFormData.append('campaign', phonesCampaign)
      return phonesFormData
    },
    uploadPhones(inputId) {
      const input = document.querySelector(`#${inputId}`)
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой базы необходимо сохранить рассылку')
        } else {
//          this.save(false)
          this.handleUploadPhonesRequest(input.files[0])
        }
      }
    },
    handleUploadPhonesRequest (phonesFile) {
      this.$http.post(PHONEBASEUPLOADING_API + '/' + 'loadForCampaign', this.prepareMultipartFile(phonesFile, this.campaign.id),
        {headers: this.prepareSecurityHeader(), timeout: 180000})
        .then(response => {
          if (response.status === 200) {
            let message = ''
            if (typeof response.data === 'string' || response.data instanceof String) {
                message = response.data
            } else if (response.data && !response.data.message) {
                message = response.data.message
            }
            if (!message) {
              this.openNotificationWithType('info', 'База загружена.')
            } else {
              this.openNotificationWithType('danger', message, 0)
            }
            this.loadTasksCount()
          } else {
            this.openNotificationWithType('danger', 'Ошибка загрузки файла')
            this.loadTasksCount()
          }
      })
    .catch(error => {
      this.openNotificationWithType('danger', 'Ошибка загрузки файла')
        this.loadTasksCount()
        console.log(error)
    })
      this.loadTasksCountPerformed()
    },
    prepareMultipartFile (phonesFile, phonesCampaign) {
      const phonesFormData = new FormData()
      phonesFormData.append('file', phonesFile)
      phonesFormData.append('campaign', phonesCampaign)
      return phonesFormData
    },
    deletePhones() {
      let that = this
      this.$http.delete(`${PHONEBASEUPLOADING_API}/${this.campaign.id}`, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.openNotificationWithType('info', that.$i18n.messages[this.$i18n.locale].notifications.campaign.baseRemoved)
          this.tasksCount = 0
//          this.save(false)
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', that.$i18n.messages[this.$i18n.locale].notifications.campaign.errorDeletePhoneBase)
        })
    },
    cancel () {
      if (this.campaign.archiveStatus) {
        this.$router.push('/archive/')
      } else {
        this.$router.push('/campaigns/')
      }
    },
    gotoScenario () {
      this.$router.push('/scenarios/' + this.campaign.id + '/' + this.campaign.scenario)
    },
    viewCallTasks () {
      this.$router.push('/callTasks/' + this.campaign.id)
    },
    viewMonitor () {
      this.$router.push('/monitoring/' + this.campaign.id)
    },
    viewCallsResult () {
      this.$router.push('/campaignCallsResult/' + this.campaign.id)
    },
    viewTestCallTasks () {
      this.$router.push('/callTasksTest/' + this.campaign.id)
    },
    // prepareReport () {
    //   this.$http.get('/report/prepareReportByCampaignId?campaignId=' + this.campaign.id)
    //     .then((response) => {
    //       this.openNotificationWithType('info', 'Отчет подготовлен')
    //       this.loadCampaign()
    //       this.loadScenarios()
    //       this.loadFsGateways()
    //     })
    //     .catch((error) => {
    //       this.openNotificationWithType('warning', 'Отчет формируется. Пожалуйста, загрузите его чуть позже.' +
    //         ' Необходимо будет обновить эту страницу, нажав Ctrl+F5')
    //       console.log(error)
    //     })
    // },
    downloadTestReport() {
      let that = this
      // this.$http.get('/report/reportByCampaignId.csv?campaignId=' + this.campaign.id)
      this.$http.get(`${TEST_REPORTS_GENERATE_API}/${this.campaign.id}`, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          var s = response.headers['content-disposition']
          var res = s.split('filename="').pop()
          res = res.split('"')[0]
          let blob = new Blob([response.data], { type: 'text/csv' })
          var a = window.document.createElement('a')
          a.href = window.URL.createObjectURL(blob)
          // a.download = 'ReportByCampaign_' + this.campaign.name + '.csv'
          a.download = res
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        })
        .catch((error) => {
          this.openNotificationWithType('danger', that.$i18n.messages[this.$i18n.locale].notifications.campaign.report.errorLoadReport)
          console.log(error)
        })
    },
    getReadyCallTasksCSV () {
      let that = this
      this.$http.get(CALLTASKS_API + '/readyCallTasksByCampaignId.csv?campaignId=' + this.campaign.id)
        .then((response) => {
          let blob = new Blob([response.data], { type: 'text/csv' })
          var a = window.document.createElement('a')
          a.href = window.URL.createObjectURL(blob)
          a.download = 'readyCallTasksByCampaign_' + this.campaign.name + '.csv'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        })
        .catch((error) => {
          this.openNotificationWithType('danger', that.$i18n.messages[this.$i18n.locale].notifications.campaign.report.errorLoadReport)
          console.log(error)
        })
    },
    setReadyStatus () {
      let that = this
      this.campaign.state = 'Подготовлена'
      // this.$http.put(CAMPAIGNS_API, this.campaign, {headers: this.prepareSecurityHeader()})
      this.$http.put(CAMPAIGNS_CTS_API + '/' + this.campaign.id + '/updatestate?state=READY', {}, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.openNotificationWithType('success', that.$i18n.messages[this.$i18n.locale].notifications.campaign.campaignIsReady)
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', that.$i18n.messages[this.$i18n.locale].notifications.campaign.errorStartCampaign)
        })
    },
    setPauseStatus () {
        let that = this
        this.campaign.state = 'Остановлена'
        // this.$http.put(CAMPAIGNS_API, this.campaign, {headers: this.prepareSecurityHeader()})
        this.$http.put(CAMPAIGNS_CTS_API + '/' + this.campaign.id + '/updatestate?state=PAUSED', {}, {headers: this.prepareSecurityHeader()})
            .then((response) => {
                this.openNotificationWithType('success', that.$i18n.messages[this.$i18n.locale].notifications.campaign.campaignStopped)
            })
            .catch((error) => {
                console.log(error)
                this.openNotificationWithType('danger', that.$i18n.messages[this.$i18n.locale].notifications.campaign.errorStopCampaign)
            })
    },
    canSetReadyStatus() {
      let result = (this.campaign.state !== 'Подготовлена' && this.campaign.state !== 'Прозвон идёт' && (this.campaign.state === 'В разработке' || this.campaign.state === 'Остановлена' || this.campaign.scheduleStrategy === 'DAILY_TIME_INTERVAL' || this.canContinue()) &&
        this.canModerate(this.permissionKey) && this.campaign.client != null &&
        this.campaign.date != null && this.campaign.scenario != null && this.campaign.zoneOffset != null &&
        this.campaign.timeStart != null && this.campaign.timeEnd && this.isReadyScenario // &&
        // ((this.campaign.postponingIntervalMin == 0 && this.campaign.postponingAttempts == 0) ||
        //   (this.campaign.postponingIntervalMin != 0 && this.campaign.postponingAttempts != 0))) // ||
      )
        // this.appconfig.campaignSetReadyButtonVisibleForAll
      return result
    },
    canPauseStatus() {
          let result = ((this.campaign.state === 'Подготовлена' || this.campaign.state === 'Прозвон идёт') && this.canModerate(this.permissionKey))
          return result
    },
    notSaved () {
      this.isSaved = false
    },
    canEdit() {
      if (this.campaign.archiveStatus) {
        return false
      }
      if (!this.isActive) {
        return false
      } else if (!this.campaign.id) {
         return true
      } else if (this.campaign.scheduleStrategy === 'DAILY_TIME_INTERVAL') {
        return true
      } else {
        if (this.loggedRole == 1) {
          return (this.campaign.state === 'В разработке') || (this.campaign.state === 'Подготовлена') || (this.campaign.state === 'Остановлена')
        } else {
          return (this.campaign.state === 'В разработке') || (this.campaign.state === 'Остановлена')
        }
      }
    },
    canContinue() {
      if (!this.isActive) {
        return false
      } else {
        return this.campaign.state === 'Завершена' && this.campaign.hasReadyTasks
      }
    },
    canLoadReport(campaign) {
      return campaign.state === 'Завершена' || campaign.scheduleStrategy === 'DAILY_TIME_INTERVAL'
    },

    callTest (showMessage) {
      let that = this
      if (!this.isSaved) {
        this.openNotificationWithType('danger', that.$i18n.messages[this.$i18n.locale].notifications.testCall.saveCampaignBeforeTestCall)
      } else {
        if (this.testPhone.trim() !== '') {
          console.log('saving new testing call task: ' + JSON.stringify(this.testPhone))
          this.$http.post(CALLTASKTESTING_API, this.prepareTestPhone(this.campaign.id, this.testPhone, this.testPhoneParametersArray), {headers: this.prepareSecurityHeader()})
            .then((response) => {
              this.testPhone = ''
              this.testPhoneParametersArray = [
                {
                  key: '',
                  value: ''
                }
              ]
              // this.callTask = response.data
              this.loadTasksCount()
              if (showMessage) {
                this.openNotificationWithType('info', that.$i18n.messages[this.$i18n.locale].notifications.testCall.testCallNumberSaved)
              }
            }).catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', that.$i18n.messages[this.$i18n.locale].notifications.testCall.errorCreatingTestCall)
          })
        }
      }
    },
    prepareTestPhoneForm (campaignId, testPhone, testPhoneParametersArray) {
      const formData = new FormData()
      formData.append('campaignId', campaignId)
      formData.append('phone', testPhone)
      let testPhoneParameters = {}
      for (let i = 0; i < testPhoneParametersArray.length; i++) {
        let item = testPhoneParametersArray[i]
        testPhoneParameters[item[0]] = item[1]
      }
      formData.append('parameters', JSON.stringify(testPhoneParameters))
      return formData
    },
    prepareTestPhone (campaignId, testPhone, testPhoneParametersArray) {
      let testCallTaskDto = {
        phone : '',
        campaign : '',
        parameters : {}
      }
      testCallTaskDto.campaign = campaignId
      testCallTaskDto.phone = testPhone
      let testPhoneParameters = {}
      for (let i = 0; i < testPhoneParametersArray.length; i++) {
        let item = testPhoneParametersArray[i]
        testPhoneParameters[item[0]] = item[1]
      }
      testCallTaskDto.parameters = testPhoneParameters
      return testCallTaskDto
    },
    checkTime() {
      return (this.regTime.test(this.campaign.timeStart) && this.regTime.test(this.campaign.timeEnd)) && (this.campaign.timeEnd.localeCompare(this.campaign.timeStart) > 0)
    },
    openNotificationWithType (type, message, duration) {
      openNotification({
        title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
        message: message,
        type: type,
        duration: duration
      })
    },
    initStartCampaign() {
      if (!this.$props.id) {
        if (!this.$props.idcopy) {
          console.log('creating new campaign')
          this.notSaved()
          this.loadState()
        } else {
          console.log('copying campaign: ' + this.name)
          this.copyCampaign()
        }
      } else {
        console.log('loading campaign: ' + this.name)
        this.loadCampaign()
      }
    },
    quotaServiceNotAvailable() {
      this.quotaServiceAvailable = false
    }
  },
  data () {
    return {
      campaign: {
        timeStart: '10:00',
        timeEnd: '18:00',
        state: '',
        scheduleStrategy: '',
        postponingAttempts: '',
        postponingIntervalMin: '',
        id: ''
      },
      loadedScenario: null,
      scenarios: [],
      tasksCount: '',
      tasksCountPerformed: 0,
      sumPayment: 0,
      reg: /^[-]?[0-9]+[.]?[0-9]{0,2}$/,
      regTime: /^(([0,1][0-9])|(2[0-3])):[0-5][0-9]$/,
      showModal: null,
      title: '',
      confirmation: true,
      isSaved: false,
      fsGateways: [],
      appconfig: {},
      isActive: false,
      isReadyScenario: false,
      clipboard: '',
      testPhone: '',
      testPhoneParametersArray: [
        {
          key: '',
          value: ''
        }
      ],
      permissionKey: 'campaign',
      phonePreprocessingParametersArray: [
        {
          key: '',
          value: ''
        }
      ],
      activeTab:0,
      quotaServiceAvailable: true
    }
  },
  created: function () {
    this.checkToken()
    this.loadAppConfig()
    this.loadFsGateways()

    this.loadScenarios()
  }
}

</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins';

.time {
  margin: 0px 5px 0px 5px;
  width: 60px;
}

.tabs {
  margin: 20px;
  .tab-content {
    min-height: 50px;
  }
}

p.phonepreprocessingparams {
  margin: -3px 10px 0px 10px;
}

  .quotasShell {
    margin-top: 32px;
    margin-bottom: 32px;
  }

  .activeTab_2 .toolButtons {
    display: none;
  }

  .report {
    display: inline-block;
  }

</style>



// WEBPACK FOOTER //
// Campaign.vue?050890f6